<div class="flex flex-col h-full bg-white overflow-hidden">
  <main class="flex-1 p-5 overflow-hidden">
    <div class="bg-gris-4 rounded-[10px] h-full flex items-center justify-center">
      <div
        [formGroup]="form"
        class="bg-white rounded-[14px] w-[612px] flex flex-col pt-[30px] pb-[30px] px-[30px]"
      >
        <!-- En-tête : icône + titre + description -->
        <div class="flex items-start gap-[15px]">
          <img
            src="assets/images/icones/session-closed.png"
            alt=""
            class="size-[68px] shrink-0 object-contain"
          />
          <div class="flex flex-col gap-[10px]">
            <p class="fg-noir-2 text-[19px] font-semibold leading-none mb-0 mt-0">
              {{ 'close_session.title' | translate }}
            </p>
            <p
              class="fg-gris-1 text-[14px] leading-[20.8px] mb-0 mt-0"
              [innerHTML]="'close_session.description' | translate: { date: date() }"
            ></p>
          </div>
        </div>

        <!-- Statistiques -->
        <div
          class="bg-[#f6f6f6] rounded-[6px] h-[80px] flex items-center px-[10px] mt-[20px] gap-[10px]"
        >
          <div class="flex items-center gap-[10px] flex-1">
            <div
              class="bg-orange-1 rounded-[5px] w-[111px] h-[60px] flex flex-col justify-center pl-[20px] gap-[4px] shrink-0"
            >
              <span class="text-white text-[19px] font-semibold leading-none">
                {{ stats().passages }}
              </span>
              <span class="text-white text-[14px] font-medium leading-none">
                {{ 'close_session.stats.passages' | translate }}
              </span>
            </div>
            <div
              class="bg-vert-1 rounded-[5px] w-[111px] h-[60px] flex flex-col justify-center pl-[20px] gap-[4px] shrink-0"
            >
              <span class="text-white text-[19px] font-semibold leading-none">
                {{ stats().validated }}
              </span>
              <span class="text-white text-[14px] font-medium leading-none">
                {{ 'close_session.stats.validated' | translate }}
              </span>
            </div>
            <div
              class="bg-rose-1 rounded-[5px] w-[111px] h-[60px] flex flex-col justify-center pl-[20px] gap-[4px] shrink-0"
            >
              <span class="text-white text-[19px] font-semibold leading-none">
                {{ stats().forced }}
              </span>
              <span class="text-white text-[14px] font-medium leading-none">
                {{ 'close_session.stats.forced' | translate }}
              </span>
            </div>
            <div
              class="bg-noir-1 rounded-[5px] w-[111px] h-[60px] flex flex-col justify-center pl-[20px] gap-[4px] shrink-0"
            >
              <span class="text-white text-[19px] font-semibold leading-none">
                {{ stats().collected | formatPrice }}
              </span>
              <span class="text-white text-[14px] font-medium leading-none">
                {{ 'close_session.stats.collected' | translate }}
              </span>
            </div>
          </div>
          <button
            type="button"
            class="bg-white border border-gris-3 rounded-[5px] size-[48px] flex items-center justify-center shrink-0 cursor-pointer hover:bg-gris-4 transition-colors"
            (click)="viewOrders()"
          >
            <app-svg class="fg-gris-2" height="22" svgPath="assets/svg/eye.svg" width="22" />
          </button>
        </div>

        <!-- Notation du service -->
        <p class="fg-noir-2 text-[16px] font-semibold mt-[25px] mb-0">
          {{ 'close_session.rating.question' | translate }}
        </p>
        <div class="flex items-center gap-[10px] mt-[10px]">
          @for (rating of ratings; track rating.value) {
            <button
              type="button"
              class="border rounded-[5px] h-[58px] px-[16px] text-[16px] font-medium fg-noir-2 cursor-pointer transition-colors flex-1 whitespace-nowrap"
              [class.border-vert-1]="selectedRating() === rating.value"
              [class.bg-vert-3]="selectedRating() === rating.value"
              [class.fg-vert-1]="selectedRating() === rating.value"
              [class.border-gris-3]="selectedRating() !== rating.value"
              (click)="selectRating(rating.value)"
            >
              {{ 'close_session.rating.' + rating.value | translate }}
            </button>
          }
        </div>

        <!-- Commentaires -->
        <div class="mt-[15px]">
          <p class="fg-noir-2 text-[16px] font-semibold mb-0">
            {{ 'close_session.comments.label' | translate }}
            <span class="fg-gris-1 font-normal text-[14px]">
              {{ 'close_session.comments.optional' | translate }}
            </span>
          </p>
          <textarea
            formControlName="comment"
            [placeholder]="'close_session.comments.placeholder' | translate"
            class="w-full h-[103px] border border-gris-3 rounded-[5px] mt-[8px] px-[20px] py-[15px] text-[14px] fg-gris-1 resize-none outline-none leading-[20.8px] italic placeholder:fg-gris-1"
          ></textarea>
        </div>

        <!-- Boutons d'action -->
        <div class="flex items-center gap-[10px] mt-[20px]">
          <button
            type="button"
            class="border border-gris-3 rounded-[5px] h-[58px] px-[20px] flex items-center gap-[10px] shrink-0 cursor-pointer hover:bg-gris-4 transition-colors fg-noir-2 text-[16px] font-medium"
            (click)="cancel()"
          >
            {{ 'close_session.cancel' | translate }}
            <app-svg
              class="fg-gris-1"
              height="22"
              svgPath="assets/svg/close-circle-full.svg"
              width="22"
            />
          </button>
          <button
            type="button"
            class="bg-vert-1 flex-1 h-[58px] rounded-[5px] text-white text-[16px] font-semibold cursor-pointer hover:brightness-95 transition-colors"
            (click)="closeSession()"
          >
            {{ 'close_session.submit' | translate }}
          </button>
        </div>
      </div>
    </div>
  </main>
</div>
